module.exports = __webpack_public_path__ + "img/default_avatar@2x.9b3dbe63.png";